module.exports = __webpack_public_path__ + "img/PC_05.c7c60c24.jpg";